$(document).ready(function () {
  
  //MODAL CLOSE FIX
  var hash = window.location.hash;
  if (hash != '' && $(hash).hasClass('modal')){
      $(hash).modal('show');
  }

  $('div.modal:not(.ignoreModalIdHash)').on('show.bs.modal', function() {
    var modal = this;
    var hash = $(this).data('hashtag') ? $(this).data('hashtag') : modal.id;
    window.location.hash = hash;
    window.onhashchange = function() {
      let modalHash = '#' + hash;

      if (location.hash !== modalHash) {
        $(modal).modal('hide');
      } else {
        $(modal).modal('show');
      }
    }
  });

$('div.modal').on('hide.bs.modal', function() {
  if (location.hash && document.referrer.includes(location.host)) {
    window.history.back();
  }

  // remove hashtag from url including # character
  history.replaceState(null, '', window.location.pathname + window.location.search);
});

$('div.modal button.close').on('click', function(){
    window.history.back();
})

$('div.modal').on('keyup', function(e) {
  if(e.key == 27)
    window.history.back();
});
//END MODAL CLOSE FIX

  var trigger = $('#hamburger'),
    isClosed = true;
  var sidebarListItem = $('.sidebar-list-item');
  var additionalCloseBtn = $('.close-sidebar');

  trigger.click(function () {
    burgerTime();
  });

  additionalCloseBtn.click(function () {
    burgerTime();
  });

  // TRIGGER LOADING ANIMATION START//

  function triggerLoader(loaderState) {
      let loader = document.getElementById('loader');
      if(loaderState) {
          loader.style.display = "block";
      } else {
          loader.style.display = "none";
      }
  }
  triggerLoader(false)

  // TRIGGER LOADING ANIMATION END//

  function burgerTime() {
    if (isClosed == true) {
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      $('#sidebarWrapper').addClass('sidebar-active');
      sidebarListItem.each(function (i) {
        setTimeout(function () {
          sidebarListItem.eq(i).addClass('sidebar-item-active');
        }, 70 * (i + 1));
      });
    } else {
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      $('#sidebarWrapper').removeClass('sidebar-active');
      sidebarListItem.each(function (i) {
        setTimeout(function () {
          sidebarListItem.eq(i).removeClass('sidebar-item-active');
        }, 70 * (i + 1));
      });
    }
  }


function scrollTop() {
    var btn = $('.scrolltop');
    $(window).scroll(function() {
        if ($(window).scrollTop() > 250) {
            btn.addClass('show-scrolltop');
        } else {
            btn.removeClass('show-scrolltop');
        }
    });

    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
    });
}

scrollTop();

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  });

  $('.skeleton-loading').children().hide();

  // var didScroll;
  // var lastScrollTop = 0;
  // var delta = 5;
  // var navbarHeight = $('.header').outerHeight();
  //
  // $(window).scroll(function(){
  //     didScroll = true;
  // });
  //
  // setInterval(function() {
  //     if (didScroll) {
  //         hasScrolled();
  //         didScroll = false;
  //     }
  // }, 250);
  //
  // function hasScrolled() {
  //     var st = $(this).scrollTop();
  //     if(Math.abs(lastScrollTop - st) <= delta)
  //         return;
  //     if (st > lastScrollTop && st > navbarHeight){
  //         $('.header').removeClass('header-down').addClass('header-up');
  //     } else {
  //         if(st + $(window).height() < $(document).height()) {
  //             $('.header').removeClass('header-up').addClass('header-down');
  //         }
  //     }
  //     lastScrollTop = st;
  // }
  //
  // $('.input-group select').change(function(){
  //     if($(this).val()){
  //         $(this).siblings('.custom-label').addClass('custom-label-active');
  //     } else {
  //         $(this).siblings('.custom-label').removeClass('custom-label-active');
  //     }
  // });
  //
  // $('.input-group input, .input-group textarea').keyup(function(){
  //     if($(this).val() !== ''){
  //         $(this).siblings('.custom-label').addClass('custom-label-active');
  //     } else {
  //         $(this).siblings('.custom-label').removeClass('custom-label-active');
  //     }
  // });

  $('.input-group input, .input-group select, .input-group textarea').change(function () {
    if ($(this).val()) {
      $(this).siblings('.input-icon').addClass('input-icon-active');
    } else {
      $(this).siblings('.input-icon').removeClass('input-icon-active');
    }
  });

  $('body').on('focus', '.input-group select', function () {
    $(this).change(function () {
      if ($(this).val()) {
        $(this).siblings('.custom-label').addClass('custom-label-active');
        $(this).siblings('.input-icon').addClass('input-icon-active');
      } else {
        $(this).siblings('.custom-label').removeClass('custom-label-active');
        $(this).siblings('.input-icon').removeClass('input-icon-active');
      }
    });
  });

  $('body').on('focus', '.input-group input, .input-group textarea', function () {
    $(this).keyup(function () {
      if ($(this).val() !== '') {
        $(this).siblings('.custom-label').addClass('custom-label-active');
        $(this).siblings('.input-icon').addClass('input-icon-active');
      } else {
        $(this).siblings('.custom-label').removeClass('custom-label-active');
        $(this).siblings('.input-icon').removeClass('input-icon-active');
      }
    });
  });


  $('.element-floating-menu').click(function () {
    $(this).siblings().removeClass('actions_dropdown_active')
    $(this).siblings().addClass('actions_dropdown_active');
  });

  $('.js-header-notification-btn').click(function (e) {
      e.preventDefault();
      $('.header-notif-list').addClass('notification-list-active');
  });

  $('.close-dropdown').click(function () {
      $('.header-notif-list').removeClass('notification-list-active');
  });

  $('.actions-dropdown li').click(function () {
     $(this).parent().removeClass('actions_dropdown_active');
  });

  // button dropdown start

  $('.dropdown-button').click(function () {
     $(".pp-actions-dropdown").addClass('actions-button-dropdown-active');
  });

  $('.pp-close-dropdown').click(function () {
     $(".pp-actions-dropdown").removeClass('actions-button-dropdown-active');
  });

  $('.pp-actions-dropdown li').click(function () {
     $(this).parent().removeClass('actions-button-dropdown-active');
  });

  $(document).mouseup(function (e) {
    var buttonActionsDropdown = $(".pp-actions-dropdown");
    if (!buttonActionsDropdown.is(e.target) && buttonActionsDropdown.has(e.target).length === 0) {
      buttonActionsDropdown.removeClass('actions-button-dropdown-active');
    }
  });

  // button dropdown end

  $(document).mouseup(function (e) {
    var elementDropdown = $('.element-dropdown');
    if (!elementDropdown.is(e.target) && elementDropdown.has(e.target).length === 0) {
      elementDropdown.children('.actions-dropdown').removeClass('actions_dropdown_active');
    }
  });


  $(document).mouseup(function (e) {
    var notificationsDropdown = $(".header-notif-list");
    if (!notificationsDropdown.is(e.target) && notificationsDropdown.has(e.target).length === 0) {
      notificationsDropdown.removeClass('notification-list-active');
    }
  });

  // $(document).mouseup(function (e) {
  //   var sidebarContent = $("#sidebarWrapper");
  //   if (!sidebarContent.is(e.target) && sidebarContent.has(e.target).length === 0) {
  //     sidebarContent.removeClass('sidebar-active');
  //   }
  // });
  //
  // $(document).mouseup(function (e) {
  //   var hamburgerMenu = $("#hamburger");
  //   if (!hamburgerMenu.is(e.target) && hamburgerMenu.has(e.target).length === 0) {
  //     hamburgerMenu.removeClass('is-closed');
  //   }
  // });

  $(document).mouseup(function (e) {
    var searchvisible = $(".search-results-box");
    if (!searchvisible.is(e.target) && searchvisible.has(e.target).length === 0) {
      searchvisible.hide();
    }
  });

  // $(".custom-select").each(function() {
  //   var classes = $(this).attr("class");
  //   var template =  '<div class="' + classes + '">';
  //       template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
  //       template += '<div class="custom-options">';
  //       $(this).find("option").each(function() {
  //         template += '<span class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
  //       });
  //   template += '</div></div>';
  //
  //   $(this).wrap('<div class="custom-select-wrapper"></div>');
  //   $(this).hide();
  //   $(this).after(template);
  // });
  // $(".custom-option:first-of-type").hover(function() {
  //   $(this).parents(".custom-options").addClass("option-hover");
  // }, function() {
  //   $(this).parents(".custom-options").removeClass("option-hover");
  // });
  // $(".custom-select-trigger").on("click", function() {
  //   $('html').one('click',function() {
  //     $(".custom-select").removeClass("opened");
  //   });
  //   $(this).parents(".custom-select").toggleClass("opened");
  //   event.stopPropagation();
  // });
  // $(".custom-option").on("click", function() {
  //   $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
  //   $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
  //   $(this).addClass("selection");
  //   $(this).parents(".custom-select").removeClass("opened");
  //   $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
  // });


  //
  // $('.input-group input, .input-group select, .input-group textarea').each(function(){
  //     if($(this).val()){
  //         $(this).siblings().addClass('label-active');
  //     } else {
  //         $(this).siblings().removeClass('label-active');
  //     }
  // });
  //
  // setTimeout(function(){
  //     $('body').trigger('click');
  //     $('.input-group input, .input-group select, .input-group textarea').each(function(){
  //         if($(this).val()){
  //             $(this).siblings().addClass('label-active');
  //         } else {
  //             $(this).siblings().removeClass('label-active');
  //         }
  //     });
  // }, 500);

});

window.showError = function (err, specificId=null) {
  if (err.response && err.response.data) {
    let errors = err.response.data
    // console.log(errors);

    if (err.response.status === 401) {
      window.Swal.fire({
        icon: 'warning',
        html: 'Va rugam sa va autentificati in contul dvs. pentru a putea face aceasta actiune.'
      });
      return ;
    }

    if (err.response.status === 404) {
      window.Swal.fire({
        icon: 'error',
        html: 'A aparut o eroare! <br>Va rugam sa incercati din nou mai tarziu!'
      });
      return ;
    }

    if (err.response.data.messages) {
      errors = err.response.data.messages
    }

    if (errors.constructor.name === "Object") {
      let err = '';
      Object.keys(errors).forEach(function (item) {
        let key = item.replace(/\./g, "-");
        let target_error = null;
        if (specificId) {
          target_error = $(`#${specificId} #${key}_error`);
        } else {
          target_error = $(`#${key}_error`);
        }
        if (target_error.length) {
          if (Array.isArray(errors[item])) {
            let temp = '';
            Object.keys(errors[item]).forEach(function (item2) {
              if (Array.isArray(errors[item][item2])) {
                Object.keys(errors[item][item2]).forEach(function (item3) {
                  temp += errors[item][item2][item3] + "<br>";
                });
              } else {
                temp += errors[item][item2] + "<br>"
              }
            });
            target_error.html(temp).addClass('count');
          } else {
            target_error.html(errors[item]).addClass('count');
          }
        } else {
          err += errors[item] + '<br>'
        }
      });
      if (err.length > 0) {
        window.Swal.fire({
          icon: 'warning',
          html: err
        }).then(() => {
          $("html, body").animate({scrollTop: 0}, "slow");
          return false;
        });
      } else {
        window.Swal.fire({
          icon: 'warning',
          html: 'Din pacate nu ati completat corect unele campuri. <br>Va rugam sa verificati erorile afisate.'
        }).then(() => {
          $("html, body").animate({scrollTop: $(".custom-input-error.count").first().offset().top - 130}, "slow");
          return false;
        });
      }
    } else {
      window.Swal.fire({
        icon: 'warning',
        html: errors
      });
    }
  } else {
    console.trace();
    window.Swal.fire({
      icon: 'error',
      html: 'A apărut o eroare! <br>Vă rugăm să încercați din nou mai târziu!'
    });
  }
}

window.formatPrice = function (price) {
  // not used. look at app.js
  return parseFloat(price).toFixed(2) + ' €'
}

window.resetErrors = function () {
  let targetDivError = $('.custom-input-error');
  targetDivError.html('');
  targetDivError.removeClass('count');
}

window.triggerLabel = function () {
  $('.input-group input, .input-group select, .input-group textarea').change(function () {
    if ($(this).val()) {
      $(this).siblings('.input-icon').addClass('input-icon-active');
    } else {
      $(this).siblings('.input-icon').removeClass('input-icon-active');
    }
  });

  $('.input-group select').change(function () {
    if ($(this).val()) {
      $(this).siblings('.custom-label').addClass('custom-label-active');
    } else {
      $(this).siblings('.custom-label').removeClass('custom-label-active');
    }
  });

  $('.input-group input, .input-group textarea').keyup(function () {
    if ($(this).val() !== '') {
      $(this).siblings('.custom-label').addClass('custom-label-active');
    } else {
      $(this).siblings('.custom-label').removeClass('custom-label-active');
    }
  });
}

window.deleteProject = function (projectId) {
  window.Swal.fire({
    title: 'Esti sigur?',
    text: "Aceste date nu vor mai putea fi recuperate!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Da, sterge!',
    cancelButtonText: 'Nu, anuleaza'
  }).then((result) => {
    if (result.value) {
      window.axios.delete(`/developer/project/${projectId}`)
        .then(function () {
          window.Swal.fire({
            html: 'Proiectul a fost sters cu succes',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false
          }).then(() => {
            window.location.reload();
          })

        })
        .catch(function (err) {
          window.showError(err)
        });
    }
  })
}

window.unpublishProject = function (projectId) {
  window.Swal.fire({
    title: 'Esti sigur?',
    text: "Acest proiect nu va mai aparea in cautarile utilizatorilor!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Da, anuleaza publicarea!',
    cancelButtonText: 'Nu, renunta'
  }).then((result) => {
    if (result.value) {
      window.axios.post(`/developer/project/${projectId}/unpublish`)
        .then(function () {
          window.Swal.fire({
            html: 'Proiectul a fost scos din lista publica de proiecte.',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false
          }).then(() => {
            window.location.reload();
          })

        })
        .catch(function (err) {
          window.showError(err)
        });
    }
  })
}

window.publishProject = function (projectId) {
  window.Swal.fire({
    title: 'Esti sigur?',
    html: "Acest proiect va deveni public pentru toti utilizatorii. <br>Va rugam sa va asigurati ca datele din proiect sunt corecte!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Da, publica!',
    cancelButtonText: 'Nu, renunta'
  }).then((result) => {
    if (result.value) {
      window.axios.post(`/developer/project/${projectId}/publish`)
        .then(function () {
          window.Swal.fire({
            html: 'Proiectul a publicat cu succes.',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false
          }).then(() => {
            window.location.reload();
          })

        })
        .catch(function (err) {
          window.showError(err)
        });
    }
  })
}

window.fallbackCopyTextToClipboard = function(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    this.copyLinkAlert(true);
  } catch (err) {
    this.copyLinkAlert(false);
    console.log(err);
  }

  document.body.removeChild(textArea);
}

window.copyTextToClipboard = function(text) {
  if (!navigator.clipboard) {
    this.fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    this.copyLinkAlert(true);
  }, function(err) {
    this.copyLinkAlert(false);
    console.log(err);
  });
}

window.copyLinkAlert = function(success) {
  let clipboardAlertContainer = document.createElement('div');
  clipboardAlertContainer.classList.add('clipboard-link-container');
  let clipboardAlert = document.createElement('span');
  clipboardAlert.appendChild(document.createTextNode('Linkul a fost copiat cu succes!'));
  clipboardAlert.classList.add('clipboard-link');
  clipboardAlertContainer.appendChild(clipboardAlert);
  document.body.appendChild(clipboardAlertContainer);
  if(!success) {
    clipboardAlert.classList.add('clipboard-link--error');
  }
  clipboardAlert.classList.add('clipboard-link-active');

  setTimeout(function(){
    clipboardAlert.classList.remove('clipboard-link-active');
    document.body.removeChild(clipboardAlertContainer);
  }, 1500)
}

window.copyLink = function (item, type) {

  //get item full url
  let text = '';
  if (type === 'project') {
    text = item.absoluteUrl;
  } else if(type === 'model'){
    text = this.getFullModelUrl(item);
  }

  //copy url to clipboard
  this.copyTextToClipboard(text);
}

window.copyLinkList = function(item) {

  let text = item.absoluteBuildingsUrl;
  this.copyTextToClipboard(text);
}

window.getFullModelUrl = function(model) {
  let hashTag = window.getModelHashTagWithType(model);
  return `${model.project.absoluteUrl}#${hashTag}`
}

window.openAddFavoriteProjectModal = function(id) {
  window.EventBus.$emit('OPEN_FAV_MODAL', {
    id: id,
    type: 'project'
  });
}
window.openAddFavoriteModelModal = function(id, projectId) {
  // console.log('model fav', id, projectId);
  window.EventBus.$emit('OPEN_FAV_MODAL', {
    id: id,
    type: 'model',
    projectId: projectId
  });
}
window.getLocalFavorites = function() {
  let favorites = window.localStorage.getItem('favorites');
  favorites = favorites ? JSON.parse(favorites) : [];
  return Array.isArray(favorites) ? favorites : [];
}
window.saveLocalFavorites = function(favorites) {
  if(!Array.isArray(favorites)) {
    favorites = (typeof favorites === 'object' && favorites !== null) ? [favorites] : [];
  }
  window.localStorage.setItem('favorites', JSON.stringify(favorites));
}
window.getLocalLastDeveloperNewsTimestamp = function() {
  let lastDeveloperNewsTimestamp = window.localStorage.getItem('lastDeveloperNewsTimestamp');
  lastDeveloperNewsTimestamp = parseInt(lastDeveloperNewsTimestamp);
  return isNaN(lastDeveloperNewsTimestamp) ? null : lastDeveloperNewsTimestamp;
}
window.saveLocalLastDeveloperNewsTimestamp = function(lastDeveloperNewsTimestamp) {
  window.localStorage.setItem('lastDeveloperNewsTimestamp', lastDeveloperNewsTimestamp.toString());
}

window.openModelDetailModal = function(projectId, modelId, from='', isAvailabilityTab=false, buildingsFilterFirst={}) {
  window.EventBus.$emit('OPEN_MODEL_DETAIL_MODAL', {
    projectId: projectId,
    modelId: modelId,
    from: from,
    isAvailabilityTab: isAvailabilityTab,
    buildingsFilterFirst: buildingsFilterFirst
  });
}

window.dateHumanize = function (date) {
  let today = window.moment().endOf('day');
  let diffInDays = today.diff(date, 'days');
  let diffInYears = today.diff(date, 'years');
  if (diffInDays === 0) {
    return window.moment(date).fromNow();
  } else if (diffInDays === 1) {
    return window.moment(date).format('[ieri la] HH:mm');
  } else if (diffInYears >= 1) {
    return window.moment(date).format('lll');
  } else {
    return window.moment(date).format('Do MMM [la] HH:mm');
  }
}

window.getAllUrlParams = function(url) {
  // get query string from url (optional) or window
  let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  let obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    let arr = queryString.split('&');

    for (let i = 0; i < arr.length; i++) {
      // separate the keys and the values
      let a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      let paramName = a[0];
      let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        let key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          let index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }
  return obj;
}

window.getProjectListRelativeUrl = function(urlParams) {
  let params = { ...urlParams };
  let citySlugs = Array.isArray(params.orase) ? params.orase : [];
  let zoneSlugs = Array.isArray(params.zone) ? params.zone : [];
  let rtdSlug = params.rtd ? 'rate-la-dezvoltator' : '';

  let typeSlug = '';
  switch (params.tip) {
    case 'apartament':
      typeSlug = 'apartamente-noi-de-vanzare';
      break;
    case 'casa':
      typeSlug = 'case-sau-vile-noi-de-vanzare';
      break;
    case 'spatiu':
      typeSlug = 'spatii-comerciale-noi-de-vanzare';
      break;
  }

  if (citySlugs.length) {
    params.orase = citySlugs.join('_');
  }

  if (zoneSlugs.length) {
    params.zone = zoneSlugs.join('_');
  }

  let isSingleCityUrl = citySlugs.length === 1;

  if (!isSingleCityUrl) {
    let query = "?" + $.param(Object.assign({}, params), true);
    if (query === "?") {
      query = "";
    }

    return "/" + query;
  }

  let pathName = '/' + citySlugs[0] +
      (zoneSlugs.length === 1 ? '/' + zoneSlugs[0] : '') +
      (typeSlug ? '/' + typeSlug : '') +
      (rtdSlug ? '/' + rtdSlug : '');

  delete params.orase;

  if (zoneSlugs.length === 1) {
    delete params.zone;
  }

  if (typeSlug) {
    delete params.tip;
  }

  if (rtdSlug) {
    delete params.rtd;
  }

  let query = $.param(Object.assign({}, params), true);
  query = query !== '' ? '?' + query : '';

  return pathName + query;
}

window.getProjectNewsfeedRelativeUrl = function(citySlugs) {
  let isSingleCityUrl = citySlugs.length === 1;

  return isSingleCityUrl
      ? '/' + citySlugs[0] + '/noutati-imobiliare'
      : '/?noutati-imobiliare=1&orase=' + citySlugs.join('_');
}

window.getModelHashTagWithoutType = function(model) {
  let roomName = model.rooms_count ? model.rooms_count.name : '';
  roomName = roomName ? roomName.trim() : '';
  let modelTypeName = model.model_type ? model.model_type.trim() : ''
  let hashTag = roomName + ' tip ' + modelTypeName;
  return hashTag.trim().replace(/[^a-zA-Z0-9-]/g, "-");
}

window.getModelHashTagWithType = function(model) {
  let hashTag = '';
  switch (model.type) {
    case 'apartment':
      hashTag = 'apartament-' + window.getModelHashTagWithoutType(model);
      break;
    case 'house':
      hashTag = 'casa-sau-vila-' + window.getModelHashTagWithoutType(model);
      break;
    case 'commercial':
      hashTag = 'spatiu-comercial-' + window.getModelHashTagWithoutType(model);
      break;
  }
  return hashTag;
}

window.getModelProfileImage = function (model, imageCategories) {
  if (model && imageCategories && imageCategories.length > 0) {
    let category = imageCategories.find(cat => cat.show_on_model === 1);
    if (category && model.media && model.media.length > 0) {
      let image = model.media.find(image => image.collection_name === 'images' && image.custom_properties.groupId === category.id)
      if (image) {
        return `${process.env.MIX_STORAGE_URL}/${image.id}/${image.file_name}`
      } else {
        return '/images/default-no-logo.jpg'
      }
    } else {
      return '/images/default-no-logo.jpg'
    }
  } else {
    return '/images/default-no-logo.jpg'
  }
}

window.setCookie = function(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

window.getCookie = function(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

window.deleteCookie = function( name ) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

window.openPublicContactModalProject = function(project,model=null) {
  window.EventBus.$emit('OPEN_PUBLIC_CONTACT_MODAL_PROJECT', {
    project: project,
    model: model
  });
}

window.openAppointmentModalProject = function(project,model=null) {
  window.EventBus.$emit('OPEN_APPOINTMENT_MODAL_PROJECT', {
    project: project,
    model: model
  })
}

window.openEditBuildingModal = function(buildingId, type) {
  window.EventBus.$emit('OPEN_EDIT_BUILDING_MODAL', {
    buildingId: buildingId,
    type: type
  });
}

window.openAddBuildingModal = function(projectId) {
  window.EventBus.$emit('OPEN_ADD_BUILDING_MODAL', {
    projectId: projectId
  });
}

window.openEditProjectAccess = function(projectId) {
  window.EventBus.$emit('OPEN_EDIT_PROJECT_ACCESS_MODAL', {
    projectId: projectId
  });
}

window.openAssignClientModal = function(item) {
  window.EventBus.$emit('OPEN_ASSIGN_CLIENT_MODAL', {
    item: item
  });
}

window.openItemDetailModal = function(itemId, canManage=false) {
  window.EventBus.$emit('OPEN_ITEM_DETAIL_MODAL', {
    itemId: itemId,
    canManage: canManage
  });
}

window.openEditModelItemsModal = function(modelId, itemId=null) {
  window.EventBus.$emit('OPEN_EDIT_MODEL_ITEMS_MODAL', {
    modelId: modelId,
    itemId: itemId
  });
}

window.openEditHouseItemsModal = function(modelId, itemId=null) {
  window.EventBus.$emit('OPEN_EDIT_HOUSE_ITEMS_MODAL', {
    modelId: modelId,
    itemId: itemId
  });
}

window.openChooseModelModal = function(projectId, types) {
  window.EventBus.$emit('OPEN_CHOOSE_MODEL_MODAL', {
    projectId: projectId,
    types: types,
  });
}

window.transformArrayToQueryParams = function(params) {
  let filtered = Object.entries(params).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
  return Object.keys(filtered).length
      ? '?' + $.param(Object.assign({}, filtered), true)
      : '';
}

window.markAsRead = function(event, link, notificationId) {
  event.preventDefault()
  window.axios.post('/notification/' + notificationId + '/mark-as-read')
    .then(function () {
      window.location.href = link
    })
    .catch(function (err) {
      window.showError(err)
    });
}

window.openEditNotesFavoriteModal = function(favoriteId) {
  window.EventBus.$emit('OPEN_EDIT_NOTES_FAV_MODAL', {
    id: favoriteId
  });
}

window.openEditNotesLocalFavoriteModal = function(favorite) {
  window.EventBus.$emit('OPEN_EDIT_NOTES_LOCAL_FAV_MODAL', {
    favorite: favorite
  });
}

window.openEditNewsfeedPostModal = function(newsfeedPost, newsfeedPostImages) {
  window.EventBus.$emit('OPEN_EDIT_NEWSFEED_POST_MODAL', {
    newsfeedPost: newsfeedPost,
    newsfeedPostImages: newsfeedPostImages,
  });
}

window.deleteModel = function (modelId) {
  window.Swal.fire({
    title: 'Esti sigur?',
    text: "Aceste date nu vor mai putea fi recuperate!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Da, sterge!',
    cancelButtonText: 'Nu, anuleaza'
  }).then((result) => {
    if (result.value) {
      window.axios.delete(`/developer/model/${modelId}`)
        .then(function () {
          window.Swal.fire({
            html: 'Modelul a fost sters cu succes',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false
          }).then(() => {
            window.location.reload();
          })

        })
        .catch(function (err) {
          window.showError(err)
        });
    }
  })
}

window.getBackLink = function() {
  return $('#link_back').val();
}

window.deleteItem = function (item) {
  if(item.client || item.notes) {
    let text = '';
    if(item.type === 'apartment') {
      text = 'Acest apartament are asignat un client sau notite!'
    } else if(item.type === 'house') {
      text = 'Acesta casa are asignat un client sau notite!'
    } else if(item.type === 'house') {
      text = 'Acest spatiu comercial are asignat un client sau notite!'
    }
    window.Swal.fire({
      title: 'Esti sigur?',
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Da, sterge!',
      cancelButtonText: 'Nu, anuleaza'
    }).then((result) => {
      if (result.value) {
        window.axios.delete(`/developer/item/${item.id}`)
          .then(function (response) {
            let html = ''
            if (response.data.data.type === 'apartment') {
              html = "Apartamentul a fost sters cu succes."
            } else if (response.data.data.type === 'house') {
              html = "Casa a fost stearsa cu succes."
            } else if (response.data.data.type === 'commercial') {
              html = "Spatiul comercial a fost sters cu succes."
            }
            window.Swal.fire({
              html: html,
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              if (response.data.data.type === 'commercial') {
                window.location.href = `/developer/project/${response.data.data.project_id}?tab=space-buildings`
              } else if (response.data.data.type === 'house') {
                window.location.href = `/developer/project/${response.data.data.project_id}?tab=house`
              } else {
                window.location.href = `/developer/project/${response.data.data.project_id}?tab=apartment-buildings`
              }
            })

          })
          .catch(function (err) {
            window.showError(err)
          });
      }
    })
  } else {
    window.Swal.fire({
      title: 'Esti sigur?',
      text: "Aceste date nu vor mai putea fi recuperate!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Da, sterge!',
      cancelButtonText: 'Nu, anuleaza'
    }).then((result) => {
      if (result.value) {
        window.axios.delete(`/developer/item/${item.id}`)
          .then(function (response) {
            let html = ''
            if (response.data.data.type === 'apartment') {
              html = "Apartamentul a fost sters cu succes."
            } else if (response.data.data.type === 'house') {
              html = "Casa a fost stearsa cu succes."
            } else if (response.data.data.type === 'commercial') {
              html = "Spatiul comercial a fost sters cu succes."
            }
            window.Swal.fire({
              html: html,
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              if (response.data.data.type === 'commercial') {
                window.location.href = `/developer/project/${response.data.data.project_id}?tab=space-buildings`
              } else if (response.data.data.type === 'house') {
                window.location.href = `/developer/project/${response.data.data.project_id}?tab=house`
              } else {
                window.location.href = `/developer/project/${response.data.data.project_id}?tab=apartment-buildings`
              }
            })

          })
          .catch(function (err) {
            window.showError(err)
          });
      }
    })
  }
}

window.togglePostContent = function (item) {
  var $expandibleOuter = $(item);
  var expandibleMaxHeight = 179;
  var classCollapsed = 'is-collapsed';
  var expandibleStyles = {
      height: expandibleMaxHeight,
      maxHeight: 'none'
  };
  var $btnExpand = `<button class="btn-expand js-btnExpand"><i class="fas fa-chevron-circle-up"></i></button>`;
  
  $expandibleOuter.each(function() {
      var $this = $(this);
      var $expandibleInner = $this.children('.js-expandibleInner');
      if ($expandibleInner.height() > expandibleMaxHeight) {
          $this
              .addClass(classCollapsed)
              .append($btnExpand);
      }
  });

  var $expandible = $expandibleOuter.filter('.is-collapsed');
  $expandible.css(expandibleStyles);
  
  $expandible.click(function() {
      var $this = $(this);
      var fullHeight = $this.children('.js-expandibleInner').height();
      var newHeight = $this.hasClass(classCollapsed) ? fullHeight : expandibleMaxHeight;

      $this.animate({height: newHeight}, 300);
      $this.toggleClass(classCollapsed);
  });
}

window.togglePostContentViewMore = function (item, maxHeight) {
  var $expandibleOuter = $(item);
  var expandibleMaxHeight = maxHeight;
  var classCollapsed = 'is-collapsed';
  var expandibleStyles = {
      height: expandibleMaxHeight,
      maxHeight: 'none'
  };
  var $btnExpand = `<button class="btn-expand js-btnExpand"></button>`;

  $expandibleOuter.each(function() {
      var $this = $(this);
      var $expandibleInner = $this.children('.js-expandibleInner');
      if ($expandibleInner.height() > expandibleMaxHeight) {
          $this
              .addClass(classCollapsed)
              .append($btnExpand);
      }
  });

  var $expandible = $expandibleOuter.filter('.is-collapsed');
  $expandible.css(expandibleStyles);

  $expandible.click(function() {
      var $this = $(this);
      var fullHeight = $this.children('.js-expandibleInner').height();
      var newHeight = $this.hasClass(classCollapsed) ? fullHeight : expandibleMaxHeight;

      $this.animate({height: newHeight}, 300);
      $this.toggleClass(classCollapsed);
  });
}

window.multibyteSubstring = function (str, start, length) {
  const characters = Array.from(str); // Convert string to an array of characters (handle multibyte)
  return characters.slice(start, start + length).join(''); // Slice and rejoin to form the substring
}

window.multibyteLength = function (str) {
  return Array.from(str).length;
}

window.truncatePostContent = function (item, xsLength, smLength, mdLength, lgLength, xlLength) {
  $(item).each(function() {
    let $this = $(this);
    if ($this.hasClass('truncated')) {
      return;
    }

    let htmlContent = $this.find('.original-text').html();
    let strippedContent = $.trim($this.text());
    let strippedContentLength = window.multibyteLength(strippedContent);

    // Insert the truncated text
    let xsTruncatedContent = $.trim(window.multibyteSubstring(strippedContent, 0, xsLength));
    let smTruncatedContent = $.trim(window.multibyteSubstring(strippedContent, 0, smLength));
    let mdTruncatedContent = $.trim(window.multibyteSubstring(strippedContent, 0, mdLength));
    let lgTruncatedContent = $.trim(window.multibyteSubstring(strippedContent, 0, lgLength));
    let xlTruncatedContent = $.trim(window.multibyteSubstring(strippedContent, 0, xlLength));

    let viewMoreBtn = '<a href="javascript:void(0)" class="truncated-view-more-btn">Vezi mai mult</a>';

    let $xsContent = $('<div class="xs-text" data-nosnippet></div>');
    if (strippedContentLength > xsLength) {
      $xsContent.text(xsTruncatedContent).append('... ').append(viewMoreBtn);
    } else {
      $xsContent.html(htmlContent)
    }
    $this.append($xsContent);

    let $smContent = $('<div class="sm-text" data-nosnippet></div>');
    if (strippedContentLength > smLength) {
      $smContent.text(smTruncatedContent).append('... ').append(viewMoreBtn);
    } else {
      $smContent.html(htmlContent)
    }
    $this.append($smContent);

    let $mdContent = $('<div class="md-text" data-nosnippet></div>');
    if (strippedContentLength > mdLength) {
      $mdContent.text(mdTruncatedContent).append('... ').append(viewMoreBtn);
    } else {
      $mdContent.html(htmlContent)
    }
    $this.append($mdContent);

    let $lgContent = $('<div class="lg-text" data-nosnippet></div>');
    if (strippedContentLength > lgLength) {
      $lgContent.text(lgTruncatedContent).append('... ').append(viewMoreBtn);
    } else {
      $lgContent.html(htmlContent)
    }
    $this.append($lgContent);

    let $xlContent = $('<div class="xl-text" data-nosnippet></div>');
    if (strippedContentLength > xlLength) {
      $xlContent.text(xlTruncatedContent).append('... ').append(viewMoreBtn);
    } else {
      $xlContent.html(htmlContent)
    }
    $this.append($xlContent);

    $('.truncated-view-more-btn', $this).on('click', function() {
      $(this).parent().html(htmlContent);
    });

    $this.addClass('truncated');
  });
}

window.updateOverlayPosition = function () {
  const header = document.querySelector('.header');
  const overlay = document.getElementById('overlay');
  const headerHeight = header.offsetHeight;

  if (!overlay) {
    return;
  }

  overlay.style.top = `${headerHeight}px`;
  overlay.style.height = `calc(100vh - ${headerHeight}px)`;
}
window.addEventListener('load', window.updateOverlayPosition);
window.addEventListener('resize', window.updateOverlayPosition);